const PAGES = {
  INFO: '/info',
  ACCOUNT: '/account',
  THANK_YOU: '/thank-you'
};

export default PAGES;
